<template>
    <div v-if="category && (category.pickups || []).length" class="main-section main-section--orange main-section--hot">
        <div class="main-section-head">
            <div class="left">
                <h3 class="title">새집추천 <b>PICK</b></h3>
            </div>
            <div class="right">
                <!-- <a class="link" href=""><span>+ 더보기</span></a> -->
            </div>
        </div>
        <div class="main-section-body">
            <!-- 쇼핑몰 메인 상품 슬라이드 : 1열 레이아웃 -->
            <div class="main-product">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div v-for="product in category.pickups" :key="product._id" class="swiper-slide">
                            <a class="product-list" href="#" @click="$router.push(`/shop/products/view?_product=${product._id}`)">
                                <span class="product-list__thumb">
                                    <span class="product-list__thumbnail">
                                        <span :data-background="product.thumb" class="swiper-lazy product-list__thumbnail-image"></span>
                                    </span>
                                    <span class="product-list__thumb-image"></span>
                                    <div class="swiper-lazy-preloader"></div>
                                </span>
                                <span class="product-list__brand">{{ (product.user || {}).name }}</span>
                                <span class="product-list__title">{{ product.name }}</span>
                                <span class="product-list__price">
                                    <span v-if="product.discountEnabled" class="product-list__price-percent">{{ product.discountRate }}%</span>
                                    <em class="product-list__price-num">{{ product.salePrice.format() }}원</em>
                                    <span v-if="product.discountEnabled" class="product-list__price-line">{{ product.price.format() }}</span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="main-product__pagination"></div>
                <div class="main-product__prev"></div>
                <div class="main-product__next"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        category: { type: Object, default: null }
    },

    methods: {
		init() {
            this.render();
		},
        render(){
            this.$nextTick(() => {
                new window.Swiper ('.main-section--hot .swiper-container', {
					allowTouchMove: true,
                    spaceBetween : 30,
                    speed: 400,
                    loop: false,
                    slidesPerView: 4,
                    slidesPerGroup: 4,
					watchSlidesVisibility: true,
					preloadImages: false,
					lazy:{
                        loadPrevNext: true,
                        loadPrevNextAmount: 1,
                    },
                    pagination: {
                        el: '.main-section--hot .main-product__pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.main-section--hot .main-product__next',
                        prevEl: '.main-section--hot .main-product__prev'
                    },
					breakpoints: {
                        500: {
							spaceBetween : 10,
                            slidesPerView: 2,
                            slidesPerGroup: 2,
							lazy: {
								loadPrevNext: true,
								loadPrevNextAmount: 1,
							},
                        },
                        768: {
							spaceBetween : 10,
                            slidesPerView: 3,
                            slidesPerGroup: 3,
							lazy: {
								loadPrevNext: true,
								loadPrevNextAmount: 1,
							},
                        },
                        1024: {
                            spaceBetween : 10,
							lazy: {
								loadPrevNext: true,
								loadPrevNextAmount: 1,
							},
                        }
                    }
                });
            });
        }
	},
    watch: {
        category(){
            if(this.category){
                this.render();
            }
        }
    }
}
</script>



